import React, { ReactNode } from 'react';
import classNames from 'classnames';

import Error from 'components/UI/Form/Error/Error';
import Label, { LabelClassesType } from 'components/UI/Form/Label/Label';
import TextWidget, {
  TextWidgetClassesType,
  TextWidgetType,
} from 'components/UI/Form/Widget/TextWidget/TextWidget';
import PasswordWidget from 'components/UI/Form/Widget/PasswordWidget/PasswordWidget';

import styles from './TextRow.module.scss';

export default function TextRow({
  children,
  classes,
  errorMessage,
  inputProps,
  label,
  message,
}: TextRowType): JSX.Element {
  const { error, name, required, type, id } = inputProps;
  const Component = type === 'password' ? PasswordWidget : TextWidget;
  const widgetClasses = {
    ...classes,
    input: classNames(classes?.input, styles.input, {
      [styles.withLabel]: label,
    }),
  };

  return (
    <>
      <Component {...inputProps} id={id || name} classes={widgetClasses}>
        {label && (
          <Label
            classes={{ label: classes?.label }}
            htmlFor={id || name}
            required={required}
          >
            {label}
          </Label>
        )}
        {children}
      </Component>
      {message && <div className={styles.message}>{message}</div>}
      {errorMessage && (
        <Error
          classes={{
            error: classNames(styles.errorMessage, classes?.errorMessage, {
              [styles.show]: !!error,
            }),
          }}
        >
          {errorMessage}
        </Error>
      )}
    </>
  );
}

export type TextRowType = React.PropsWithChildren<{
  classes?: TextRowClassesType;
  errorMessage?: string | JSX.Element;
  inputProps: Omit<TextWidgetType, 'children' | 'classes'> & {
    name: string;
  };
  label?: ReactNode;
  message?: string | JSX.Element;
}>;

type TextRowClassesType = { errorMessage?: string } & TextWidgetClassesType &
  LabelClassesType;
